import {
    FETCH_REVIEWS, REVIEWS_SUCCESS, REVIEWS_FAIL,
    SUBMIT_REVIEW, SUBMIT_REVIEW_SUCCESS, SUBMIT_REVIEW_FAIL
} from './index';
import api from '../utils/axiosInstance';
import { addreview, getreviews } from '../constant/routes';
import { toast } from 'react-toastify';

export const fetchReviews = (productId) => async (dispatch) => {
    dispatch({ type: FETCH_REVIEWS });
    const res = await api.get(getreviews + productId)
        .then(r => r)
        .catch(err => err);
    if (res.status === 200) {
        dispatch({ type: REVIEWS_SUCCESS, payload: res.data.reviews });
    } else {
        dispatch({ type: REVIEWS_FAIL, payload: res.message });
    }
};

export const submitReview = (productId, reviewData) => async (dispatch) => {
    dispatch({ type: SUBMIT_REVIEW });
    const res = await api.post(addreview + productId, reviewData)
        .then(r => r)
        .catch(err => err);
    if (res.status === 200) {
        dispatch({ type: SUBMIT_REVIEW_SUCCESS });
        toast.success('Review submitted!');
        dispatch(fetchReviews(productId));
    } else {
        dispatch({ type: SUBMIT_REVIEW_FAIL, payload: res.message });
        toast.error(res.message || 'Failed to submit review');
    }
};
